import {RemoteGetNetworkFilters} from 'data/usecases/private/guide-flow/medical-guide/remote-get-network-filters';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetNetworkFilters = () =>
	new RemoteGetNetworkFilters(
		makeBFFApiUrl(GuideFlowEndpoints.medicalGuideTypeNetwork),
		makeAuthorizeHttpClientDecorator(),
	);
